import React from 'react';
import { Link } from 'react-router-dom';
import HeroImage from '../assets/imgs/pexels-pixabay-60512.jpg';

function Hero() {
  return (
    <section className="relative bg-gradient-to-r from-charcoal to-moss-dark h-[80vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-black/50 z-10"></div>
      <div className="relative z-20 text-center max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl md:text-6xl font-bold text-ivory mb-6 tracking-tight">
          Discover Rare Reptiles & Snakes
        </h1>
        <p className="text-lg md:text-xl text-bone mb-8">
          Connect with trusted breeders and explore a curated marketplace for unique reptiles.
        </p>
        <div className="flex justify-center space-x-4">
          <Link
            to="/listings"
            className="bg-copper text-ivory px-6 py-3 rounded-md font-medium hover:bg-copper-dark transition-colors duration-300"
          >
            Browse Listings
          </Link>
          <Link
            to="/add"
            className="bg-transparent border-2 border-ivory text-ivory px-6 py-3 rounded-md font-medium hover:bg-ivory hover:text-charcoal transition-colors duration-300"
          >
            Add Your Listing
          </Link>
        </div>
      </div>
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{ backgroundImage: `url(${HeroImage})` }}
      ></div>
      {/* Wavy bottom edge */}
      <div
        className="absolute bottom-0 left-0 right-0 h-20 z-20 w-full"
        style={{
          background: 'rgb(248, 241, 233)',
          clipPath: 'path("M1481.59,14.6c-223.36,32.85-291.04,0-291.04,0,0,0-80.87-32.85-304.23,0-223.36,32.85-291.04,0-291.04,0,0,0-80.87-32.85-304.23,0C67.69,47.45,0,14.6,0,14.6v77.37h1785.83V14.6s-80.87-32.85-304.23,0Z")',
          transform: 'scaleX(2)',
          display: 'flex',
        }}
      ></div>
    </section>
  );
}

export default Hero;